<div>
  <div class="notch" (swipedown)="closeBottomSheet()"></div>
  <section class="d-flex pt-1 pb-4 position-relative" (swipedown)="closeBottomSheet()">
    <div class="responsive-header">{{ 'Filter' }}</div>
  
    <!-- Simple Transparent OK Button -->
    <button class="ok-button" type="button" class="btn btn-primary" (click)="closeBottomSheet()">{{ translationScope + '.titles.go_to_courses' | transloco }}</button>
  
    <div class="reset-filter align-items-end" style="margin-left: auto" (click)="resetFiltersAndSearch()">
      <img src="assets/icons/refresh.svg" alt="">
      <span>{{ 'Nullstill' }}</span>
    </div>
  </section>
  


  <app-filter-search
    class="pb-3"
    [placeholder]="data.search.placeholder"
    [value]="data.search.value"
    (search)="updateSearchFilter($event)"
  ></app-filter-search>

  <div *ngFor="let filter of data.filters; let i=index">
    <div class="header-5 pb-2">{{ filter.label }}</div>
    <ul>
      <ng-container *ngFor="let option of filter.options; let j=index">
        <li *ngIf="j<optionsState[i].visible">
          <mat-checkbox
            class="pg-default"
            [(ngModel)]="option.selected"
            color="primary"
          >{{ option.label }}
          </mat-checkbox>
        </li>
      </ng-container>
    </ul>

    <ng-container *ngIf="optionsState[i].total > 3">
      <button
        class="expand-shrink-button mt-n4"
        *ngIf="optionsState[i].visible !== optionsState[i].total; else showLessButton"
        (click)="toggleButton(i)">
        <span>{{ 'Vis mer' }}</span>
        <mat-icon>expand_more</mat-icon>
      </button>

      <ng-template #showLessButton>
        <button
          class="expand-shrink-button mt-n4"
          *ngIf="optionsState[i].visible === optionsState[i].total"
          (click)="toggleButton(i)">
          <span>{{ 'Vis mindre' }}</span>
          <mat-icon>expand_less</mat-icon>
        </button>
      </ng-template>
    </ng-container>
    <hr *ngIf="i < data.filters.length - 1">
  </div>

  <ng-container *ngIf="showDateFilter()">
    <hr>
    <div class="header-5 pb-2">{{ 'Dato' }}</div>
    <button
      class="shadow-button"
      (click)="toggleDatePicker()">
      {{ dateFilterLabel }}
      <div class="arrow-down" [ngStyle]="isDateFilterExpanded && {'transform': 'rotateX(180deg);'}"></div>
    </button>
    <app-date-filter
      *ngIf="showDatePicker"
      [fromDate]="data?.dateRange?.from"
      [toDate]="data?.dateRange?.to"
      (save)="saveDate($event)"
      (clear)="clearDate()"
    ></app-date-filter>
  </ng-container>
</div>

